import React from "react"
import { Link as ThemeUiLink } from "theme-ui"
import Link from "./link"

export const ButtonLink = props => (
  <Link
    {...props}
    sx={{
      padding: 3,
      backgroundColor: "primary",
      color: "light",
      textDecoration: "none",
    }}
  />
)

export const ExternalButtonLink = props => (
  <ThemeUiLink
    {...props}
    sx={{
      display: "inline-block",
      paddingX: 4,
      paddingY: 2,
      border: "1px solid",
      borderColor: "primary",
      backgroundColor: "primary",
      color: "light",
      textDecoration: "none",
    }}
    target="blank"
    rel="noopener nofollow"
  />
)

export const ExternalButtonLinkSecondary = props => (
  <ThemeUiLink
    {...props}
    sx={{
      display: "inline-block",
      paddingX: 4,
      paddingY: 2,
      border: "1px solid",
      borderColor: "primary",
      color: "primary",
      textDecoration: "none",
    }}
    target="blank"
    rel="noopener nofollow"
  />
)
